import React from 'react';
import {connect} from 'react-redux';
import TeamLogo from 'components/molecules/team-logo';
import PlayerInjury from 'components/molecules/player-injury';
import {LineupPlayersSketch} from 'components/organisms/lineup/components/lineup-players/sports/nhl/classic';

class LineupPlayersComponent extends LineupPlayersSketch {
    render() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        if (!lineup) {
            return null;
        }

        const rows = lineup.players.map((player) => {
            return (
                <tr key={player.playerId} className={this.getRowClassName(player)}>
                    <td>
                        <strong className={this.getStackClassName(player)}>{player.name}</strong>
                        <PlayerInjury player={player} />
                    </td>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <TeamLogo teamName={player.team.toUpperCase()} />
                    </td>
                    <td>
                        <strong className="text-gray">{player.salary}</strong>/{this.getPlayerPointsView(player)}
                    </td>
                </tr>
            );
        });

        return (
            <table className="table">
                <tbody>{rows}</tbody>
            </table>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups, rawLineups},
        filterLineupsByPlayer,
        nhlTeamStacking,
        nhlLegacyTeamStacking,
    } = state;

    return {
        lineups,
        rawLineups,
        filterLineupsByPlayer,
        nhlTeamStacking,
        nhlLegacyTeamStacking,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
